export default __webpack_public_path__ + "static/media/Android.dfbcea65.svg";